<div class="modal__content" style="display: flex;">
    <p class="shipping-account-alert">By choosing to ship via your personal FedEx account, you hereby acknowledge that your package will not be insured for any amount by SGC, and that applicable shipping rates may not be lower than those offered by SGC.</p>
</div>
<div class="modal__actions" style="display: flex; justify-content: flex-end; ">
    <!-- <button class="button button--secondary" (click)="close()">Cancel</button> -->
    <button class="button" (click)="accept()">Continue</button>
</div>    